import { useFormState } from 'utils/hooks';
import Input from 'common/components/form/inputs/Input';
import Switch from 'common/components/form/inputs/Switch';

const Body = ({ formState, accountIsAdmin }) => {
  const { fields, changeField, selectField } = useFormState(formState);

  return (
    <>
      <Input label="Name" placeholder="Set name" onChange={changeField('name')} {...fields.name} />
      <Input
        label="Username"
        placeholder="Set username"
        onChange={changeField('username')}
        {...fields.username}
      />
      <Input
        label="Password"
        type="password"
        placeholder="Set password"
        onChange={changeField('password')}
        showValidation
        {...fields.password}
      />
      <Input
        label="Confirm Password"
        placeholder="Repeat password"
        onChange={changeField('confirm_password')}
        type="password"
        {...fields.confirm_password}
        error={
          fields.password.value &&
          fields.confirm_password.value &&
          fields.password.value !== fields.confirm_password.value
            ? "Passwords don't match"
            : fields.confirm_password.error
        }
      />

      <div className="form-label">Ocean Admin</div>

      <div className="d-flex aling-items-center">
        <Switch
          onChange={() => selectField('is_admin')(fields.is_admin.value ? false : true)}
          className="mb-0 justify-content-center"
          size="sm"
          switchClassName="green-switch"
          disabled={!accountIsAdmin}
          {...fields.is_admin}
        />
        <strong
          className={`fs-12 fw-medium ps-1 text-${
            fields.is_admin.value ? 'turquoise' : 'secondary'
          }`}
        >
          {fields.is_admin.value ? 'Yes' : 'No'}
        </strong>
      </div>

      <div className="my-3 border-bottom"></div>

      <div className="text-violet fs-10 fw-medium">
        *On first login, user will be asked to set up authenticator app.
      </div>
    </>
  );
};

export default Body;
